import React from 'react';
import '../Font&Color.css';
import '../thumbnail&details.css';
import '../divs.css';


export default function CEO인사말() {
  return (
    <>CEO인사말</>
  );
}
